import { useColorMode } from "../../theme/ThemeProviderWrapper";

export const useGetColor = () => {
  const { mode } = useColorMode();
  return (index, total) => {
    const minHue = 0;
    const maxHue = 360;
    const hueStep = (maxHue - minHue) / Math.max(total, 1);

    const hue = minHue + index * hueStep;

    const saturation = mode === "dark" ? 90 : 70;
    const lightness = mode === "dark" ? 75 : 55;

    return `hsla(${hue}, ${saturation}%, ${lightness}%, 1)`;
  };
};
